import { render, staticRenderFns } from "./PartnerRegisterNew.vue?vue&type=template&id=df9e9152&"
import script from "./PartnerRegisterNew.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports